"use strict";
var sticky_directive_1 = require("./sticky.directive");
exports.NguiStickyDirective = sticky_directive_1.NguiStickyDirective;
var sticky_module_1 = require("./sticky.module");
exports.NguiStickyModule = sticky_module_1.NguiStickyModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngui/sticky/dist/index.js
// module id = 567
// module chunks = 4